import AddSubCategoryModal from './AddSubCategoryModal';

export default AddSubCategoryModal;
